import dayjs from "dayjs";

export function parseToDate(value) {
  if (!value) return null;
  if (value instanceof Date) return Number.isFinite(value.getTime()) ? value : null;
  const d = dayjs(value);
  return d.isValid() ? d.toDate() : null;
}

export function normalizeRange(range) {
  const fromRaw = range?.from ?? range?.start ?? null;
  const toRaw = range?.to ?? range?.end ?? null;

  const from = parseToDate(fromRaw);
  const to = parseToDate(toRaw);

  if (!from && !to) return null;

  const startMs = from ? dayjs(from).startOf("day").valueOf() : null;
  const endMs = to
    ? dayjs(to).endOf("day").valueOf()
    : from
      ? dayjs(from).endOf("day").valueOf()
      : null;

  return { startMs, endMs };
}

export function getDataDateRange(data) {
  if (!Array.isArray(data) || data.length === 0) return null;

  let min = Infinity;
  let max = -Infinity;

  for (const row of data) {
    const d = parseToDate(row?.date);
    if (!d) continue;
    const t = d.getTime();
    if (t < min) min = t;
    if (t > max) max = t;
  }

  if (!Number.isFinite(min) || !Number.isFinite(max)) return null;

  return { from: new Date(min), to: new Date(max) };
}
